const privateLibrary = {}

export default privateLibrary
